import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';
import { useAuth } from '../contexts/AuthContext';
import { setLogoutFlag } from '../utils/sessionUtils';

const ExitDemoModeButton = ({ user }) => {
  const { isDarkMode } = useDarkMode();
  const { logout } = useAuth();
  
  if (!user || !user.demo_mode) {
    return null;
  }

  const handleExitDemoMode = async () => {
    setLogoutFlag();
    await logout('/demo-login');
  };
  
  return (
    <button
      onClick={handleExitDemoMode}
      className={`fixed bottom-4 right-4 z-50 px-4 py-2 rounded-md ${
        isDarkMode ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600'
      } text-white shadow-lg transition-colors duration-200 flex items-center`}
      aria-label="Exit Demo Mode"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className="h-5 w-5 mr-1" 
        viewBox="0 0 20 20" 
        fill="currentColor"
      >
        <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H3zm11 4a1 1 0 10-2 0v4.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L14 11.586V7z" clipRule="evenodd" />
      </svg>
      Exit Demo Mode
    </button>
  );
};

export default ExitDemoModeButton;
